// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__9Tvn7","tab":"Tabs_tab__3l6vz","tabActive":"Tabs_tabActive__P2RiP"};